import { OrderStatus as OrderStatusKind } from "common/types/orders";

import Status from "client/common/components/content/Status";

import { getColorForOrderStatus, getLabelForOrderStatus } from "../utils";

type OrderStatusProps = {
  order: { status: OrderStatusKind };
};

const OrderStatus = ({ order }: OrderStatusProps) => {
  return (
    <Status color={getColorForOrderStatus(order.status)}>
      {getLabelForOrderStatus(order.status)}
    </Status>
  );
};

export default OrderStatus;
